import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import '../productsItem1/dialog.css'
import ProductImage from '../../assets/images/defult-img.svg';
import Collapse from '../../assets/icons/collapse.svg';
import CloseCollapse from '../../assets/icons/close-collaps.svg';
import { Dialog } from 'primereact/dialog';
import Carousel from 'react-bootstrap/Carousel';
import { imgBaseUrl2 } from '../../utils/api'
import { Rating } from "primereact/rating";

function ProductsListItem({ product }) {
  const [visible, setVisible] = useState(false); // Dialog visibility state
  const [dialogContent, setDialogContent] = useState({}); // Dialog content state
  const [isScrolling, setIsScrolling] = useState(false); // فلگ برای تشخیص اسکرول
  const carouselRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);
  const openDialog = (product) => {
    setDialogContent(product); // Set content for the dialog
    setVisible(true); // Show dialog
  };

  // Check if images are available, otherwise use the default image
  const imagesToShow = product.images && product.images.length > 0 ? product.images : [ProductImage];
  const gotoDetail = (id) => {
    window.location.href = `/product?id=${id}`
  }

  useEffect(() => {
    if (visible) {
      // Disable scroll
      document.body.style.overflow = 'hidden';
    } else {
      // Enable scroll
      document.body.style.overflow = 'auto';
    }

    return () => {
      // Clean up by enabling scroll if component unmounts
      document.body.style.overflow = 'auto';
    };
  }, [visible]);

  // برای جلوگیری از فراخوانی بیش از حد در هر حرکت موس
  const throttle = (func, delay) => {
    let lastCall = 0;
    return (...args) => {
      const now = Date.now();
      if (now - lastCall >= delay) {
        lastCall = now;
        func(...args);
      }
    };
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX);
  };

  const handleMouseMove = throttle((e) => {
    if (!isDragging) return;

    setCurrentX(e.clientX);
  }, 16); // مقدار 16ms برای استفاده از throttle و جلوگیری از فراخوانی زیاد تابع

  const handleMouseUp = () => {
    setIsDragging(false);
    const deltaX = currentX - startX;

    if (deltaX > 50) {
      if (carouselRef.current) {

        carouselRef.current.prev(); // اسلاید قبلی
      }
    } else if (deltaX < -50) {
      if (carouselRef.current) {

        carouselRef.current.next(); // اسلاید بعدی
      }
    }

    // ریست مقادیر
    setStartX(0);
    setCurrentX(0);
  };
  const getDefaultImage = (images) => {
    if (!images || images.length === 0) return ProductImage;
    const defaultImg = images.find(img => img.isDefault);
    return defaultImg
      ? imgBaseUrl2 + 'io/230x230/' + defaultImg.url
      : imgBaseUrl2 + 'io/230x230/' + images[0].url;
  };

  return (
    <>
      <div className='product-item' >
        <div className='product-img ' onClick={(e) => gotoDetail(product.id)}>
          {/* Display the first image or default if no images exist */}
          <img src={getDefaultImage(product.images)} className='img-box img-product aspect-[3/3]' alt="Product" />
        </div>
        <div className='detail' onClick={(e) => gotoDetail(product.id)}>
          <h4 className='mt-4'>{product.title || "نام محصول"}</h4>
          <h6 className="" dir="rtl">
            {product && product.lables
              ? product.lables.filter(Boolean).join(' , ')
              : ''}
          </h6>
        </div>
        <div className='max-btn'>
          <div className='max-btn-top'></div>
          <div className='max-btn-down'></div>
          <button onClick={() => openDialog(product)} className='btn'>
            <img src={Collapse} alt="Expand" />
          </button>
        </div>
      </div>

      {/* Dialog with Carousel for Product Details */}
      <Dialog
        visible={visible}
        style={{ width: '24vw' }}
        breakpoints={{  '1800px': '25vw','1600px': '24vw','1100px': '60vw','900px':'60vw','600px': '400vw', '500px': '95vw' }}
        onHide={() => setVisible(false)}
        className="custom-dialog"
      >
        <div onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={() => setIsDragging(false)}
          style={{ cursor: isDragging ? "grabbing" : "grab" }}>
          <Carousel
            ref={carouselRef}
            indicators={
              dialogContent &&
              dialogContent.images &&
              dialogContent.images.length > 1
            }
            controls={
              dialogContent &&
              dialogContent.images &&
              dialogContent.images.length > 1
            }
          >
            {(dialogContent.images && dialogContent.images.length > 0
              ? dialogContent.images
              : [ProductImage]
            ).map((image, index) => (
              <Carousel.Item key={index}>
                <div className="img-box aspect-[3/3]">
                  <img
                    src={image.url ? imgBaseUrl2 + 'io/420x420/' + image.url || image : image}
                    className="img-slider"
                    alt={`Product ${index + 1}`}
                    draggable={false}
                  />
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
          <h4>{dialogContent.title}</h4>
          <p className='mb-1'>
            توضیحات محصول:{' '}
            {dialogContent.description || 'این محصول فاقد توضیحات می‌باشد.'}
          </p>
          <h6 className="" dir="rtl">
            {dialogContent && dialogContent.lables
              ? dialogContent.lables.filter(Boolean).join(' , ')
              : ''}
          </h6>

          <div className='dailog-max-btn-right'></div>
          <div className='dailog-max-btn-left'></div>
          <div className='bg-modal'>
            <div className="dailog-max-btn">

              <button className="btn" onClick={() => setVisible(false)}>
                <img src={CloseCollapse} alt="Collapse" />
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}

// Define prop types for ProductsListItem
ProductsListItem.propTypes = {
  product: PropTypes.shape({
    images: PropTypes.arrayOf(PropTypes.string), // Array of image URLs
    title: PropTypes.string,
    description: PropTypes.string,
    size: PropTypes.string,
  }),
};

export default ProductsListItem;
